/* eslint-disable max-len */
import * as textKeys from 'src/common/constants/localizations/shared';
import { getRadioPathname } from 'src/common/utils/guideItem/getGuideItemPathname';
import { pathsToGuideIds } from 'src/data/rootCategories.json';

export default function getNavigationItems(iHeartGuideId) {
  return [
    {
      guideId: pathsToGuideIds.home,
      dataTestId: 'home',
      path: getRadioPathname('home'),
      textKey: textKeys.HOME,
    },
    {
      guideId: pathsToGuideIds.premium,
      dataTestId: 'premium',
      path: getRadioPathname('premium'),
      textKey: textKeys.PREMIUM,
    },
    {
      guideId: pathsToGuideIds.local,
      dataTestId: 'local',
      path: getRadioPathname('local'),
      textKey: textKeys.LOCAL_RADIO,
    },
    {
      guideId: pathsToGuideIds.recents,
      dataTestId: 'recents',
      path: getRadioPathname('recents'),
      textKey: textKeys.RECENTS,
    },
    iHeartGuideId
      ? {
          guideId: iHeartGuideId,
          dataTestId: 'iheart',
          path: getRadioPathname(`Stream-iHeartRadio-${iHeartGuideId}`),
          textKey: textKeys.IHEART,
        }
      : {},
    {
      guideId: pathsToGuideIds.trending,
      dataTestId: 'trending',
      path: getRadioPathname('trending'),
      textKey: textKeys.TRENDING,
    },
    {
      guideId: pathsToGuideIds.music,
      dataTestId: 'music',
      path: getRadioPathname('music'),
      textKey: textKeys.MUSIC,
    },
    {
      guideId: pathsToGuideIds.sports,
      dataTestId: 'sports',
      path: getRadioPathname('sports'),
      textKey: textKeys.SPORTS,
    },
    {
      guideId: pathsToGuideIds.news,
      dataTestId: 'news',
      path: getRadioPathname('News--Talk-c57922'),
      textKey: textKeys.NEWS_AND_TALK,
    },
    {
      guideId: pathsToGuideIds.podcasts,
      dataTestId: 'podcasts',
      path: '/podcasts/',
      textKey: textKeys.PODCASTS,
    },
    {
      guideId: pathsToGuideIds.regions,
      dataTestId: 'regions',
      path: getRadioPathname('regions'),
      textKey: textKeys.BY_LOCATION,
    },
    {
      guideId: pathsToGuideIds.languages,
      dataTestId: 'languages',
      path: getRadioPathname('languages'),
      textKey: textKeys.BY_LANGUAGE,
    },
  ];
}
